import React from "react"
import HeroSection from "./components/HeroSection"
import AboutSection from "./components/AboutSection"
import ProductCategories from "./components/ProductCategories"

const HomePage: React.FC = (): JSX.Element => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="py-4 lg:py-8">
        <HeroSection />
        <AboutSection />
        <ProductCategories />
      </div>
    </div>
  )
}

export default HomePage
